export default __webpack_public_path__ + "assets/sounds/29899f9a8f090882b4ae9dca2efdf384.mp3";